// extracted by mini-css-extract-plugin
module.exports = {"card":"NewsCard_card__YUGQT","container":"NewsCard_container__FgNTR","copy":"NewsCard_copy__I6L7X","subheading":"NewsCard_subheading__aAMrd"};